<template>
  <div  class="pr header_web">
      <div class="w1200 m0">
        <h1 style="font-size: 22px" ><img src="/static/images/jplogo.png" width="50" class="mr10">{{platName}}</h1>
      </div>
      <ul class="pa header-right">
        <!-- <router-link to='/login' tag="li" v-if="isLogin == false" class="first"><a href="javascript:;">登录</a></router-link>-->
        <!-- <li><a href="javascript:;" v-if="isLogin == false" @click="register()">注册</a></li>-->
        <li><a href="javascript:;"  @click="logout()">退出登录</a></li>
      </ul>
  </div>
</template>
<style>
  .header_web{height: 60px;line-height: 60px;background: #0b60a2;color: #fff;}
  .header-right{right: 10px;top: 0px;}
  .header-right li{float: left;padding: 0 15px;color: #fff;}
  .header-right li a{color: #fff;font-size: 14px;}
</style>

<script>

export default {
  name: 'headTop',
  data () {
    return {
      isLogin : false,
      platName:process.env.TITLE_NAME,
      webUrl:process.env.WEB_URL,
      // platLogo:process.env.PLAT_LOGO,
     }
  },
  methods:{
    /* 退出 */
    logout(){
      this.$confirm("确定要退出吗", '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
        this.logoutFun();
      });
    },
    logoutFun(){
      this.$axiosPackag.get('/api/student/user/logout',null , res => {
        this.$sessionStore.clearSession();
        window.parent.location.href=this.webUrl;
      });
    },
  },

    mounted() {

  }
}
</script>




// WEBPACK FOOTER //
// Top.vue?4a5a083c